import { Queue } from "@/types/queue";
import { HeaderProfile } from "./header/HeaderProfile";
import { HeaderActions } from "./header/HeaderActions";
import { HeaderTitle } from "./header/HeaderTitle";

interface HeaderProps {
  companyName: string;
  onSignOut: () => Promise<void>;
  onCreateQueue: (queue: Omit<Queue, "id">) => Promise<void>;
}

export const Header = ({ companyName, onSignOut, onCreateQueue }: HeaderProps) => {
  return (
    <div className="w-full rounded-lg border bg-card text-card-foreground shadow-sm">
      <div className="relative flex flex-col gap-6 p-6 sm:flex-row sm:items-center sm:justify-between">
        <HeaderTitle companyName={companyName} />
        <div className="flex flex-wrap gap-3 items-center">
          <HeaderProfile onSignOut={onSignOut} />
          <HeaderActions onCreateQueue={onCreateQueue} />
        </div>
      </div>
    </div>
  );
};